module.exports = global["$"] = require("-!/biblio-ui-core/node_modules/expose-loader/index.js?jQuery!/biblio-ui-core/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 2450
// module chunks = 0